/***
 *
 *
 * @description
 * @author jinshakappil
 */
import { EditOutlined } from '@ant-design/icons';

import React, { useEffect, useState } from 'react';

import { Clinicals, Opvisits, Opreg } from '../../../../models';

import { Radio, Skeleton, Modal, Input, Button, Typography, Col, Row } from 'antd';

import VitalInformation from '../vital-information/vital-information';

import { Location, DateUtils, useTranslation, Card } from 'soxo-bootstrap-core';

import './clinical-information.scss';

const { TextArea } = Input;
const { Text } = Typography;

const getColor = (label) => {
    const redLabels = ['Systolic', 'Diastolic'];
    const greenLabels = ['BMI', 'Pulse'];
    if (redLabels.includes(label)) return 'red';
    if (greenLabels.includes(label)) return 'green';
    return undefined;
};

const MetricItem = ({ label, value, unit }) => {
    return (
        <div className='matric-item'>
            <Text type="secondary">{label}:</Text>
            <Text style={{ color: getColor(label) }}>{value ? `${value} ${unit}` : '-'}</Text>
        </div>
    );
};

/**
 *
 */
export default function ClinicalInformation({
    bill,
    // t,

    visit_id,
    histories,
    enableModel,
    module,
    refrence_number,
    refrence_id,
    readOnlyMode,
    isTimeTracking,
    currentRoomPointer,
    attributes,
}) {
    const { t, i18n } = useTranslation(); // To Translate to another language

    const [loading, setLoading] = useState(true);

    const [clinical, setClinical] = useState({});

    let [history, setHistory] = useState([]);

    let urlParams = Location.search();
// Grouped clinical data to display in rows of two items each
    const data = [
        [
            { label: 'Systolic', value: clinical.srvbcd_bpsys, unit: t('mmHg') },
            { label: 'Diastolic', value: clinical.srvbcd_bpdia, unit: t('mmHg') },
        ],
        [
            { label: 'Height', value: clinical.srvbcd_height, unit: t('cm') },
            { label: 'Weight', value: clinical.srvbcd_weight, unit: t('kg') },
        ],
        [
            { label: 'BMI', value: clinical.srvbcd_bmi, unit: t('kg/m^2') },
            { label: 'Pulse', value: clinical.srvbcd_pulse, unit: t('bpm') },
        ],
        [
            { label: 'SpO2', value: clinical.srvbcd_spo2, unit: t('%') },
            { label: 'Temperature', value: clinical.srvbcd_temperature, unit: t('°C') },
        ],
    ];

    // Use the useLocation hook to get URL parameters

    useEffect(() => {
        getClinicalData(visit_id);

        getPatientHistory(urlParams.opno);
    }, []);

    /**
     * Get the patient history
     *
     * @param {*} op_number
     */
    function getPatientHistory(op_number) {
        setLoading(true);

        Opvisits.getPatientHistory(op_number).then(async (result) => {
            if (result.result.length) {
                let visits = result.result;

                await Promise.all(
                    visits.map((visit) => {
                        return Clinicals.getVitalInformation(visit.visit_id).then((response) => {
                            if (response.result.length) {
                                response.result.forEach((record) => {
                                    history.push({
                                        Cases: record.srvbcd_weight,
                                        Date: DateUtils.formatDate(visit.date),
                                    });
                                });

                                // history = [].concat(history, response.result)
                            }

                            setLoading(false);
                        });
                    })
                );

                console.log(history);

                // let format = history.map((record) => {

                //     return ({
                //         Date: '10/10/2021',
                //         Cases: record.srvbcd_weight
                //     })
                // })

                setHistory(history);
            }

            setLoading(false);
        });
    }

    /**
     * get clinical data
     */
    async function getClinicalData(visit_id) {
        setLoading(true);

        await Clinicals.getVitalInformation(visit_id).then((result) => {
            if (result.result[0]) {
                setClinical(result.result[0]);
            } else {
                setClinical({});
            }

            setLoading(false);
        });
    }

    const [visible, setVisible] = useState(false);

    const [formToShow, setFormToShow] = useState(null);

    /**
     *  edit for clinical information
     */
    function editClinicalinformation(formIdentifier) {
        setFormToShow(formIdentifier);
        // Location.navigate({ url: `/vital-information/${visit_id}?opvisit_id=${visit_id}&redirect=true` });
        setVisible(true);
    }

    return (
        <Card className="clinical-card card card-shadow">
            {/* <div className="card-header"> */}
            <div className="card-title">
                {/* <h3>{t('CLINICAL INFORMATION')}</h3> */}

                <div className="card-actions">
                    {/*  */}
                    {enableModel || readOnlyMode ? null : (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <div>
                                {/** If the histories returns true then edit is disabled (Show the emr screen contains patient history tab) else edit enabled.*/}
                                <Button
                                    size="small"
                                    onClick={() => {
                                        editClinicalinformation('form1');
                                    }}
                                >
                                    {t('Height/ Weight')}
                                    {!histories ? <EditOutlined style={{ color: 'black' }} /> : null}
                                </Button>
                            </div>

                            <div>
                                {/** If the histories returns true then edit is disabled (Show the emr screen contains patient history tab) else edit enabled.*/}
                                <Button size="small" onClick={(edit) => editClinicalinformation('form2')}>
                                    {t('Blood Pressure')}
                                    {!histories ? <EditOutlined style={{ color: 'black' }} /> : null}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>

                {enableModel ? null : (
                    <Modal
                        destroyOnClose={true}
                        title={t('Vital Information')}
                        visible={visible}
                        footer={null}
                        okText="Okay"
                        onOk={() => {
                            setVisible(false);
                            // onCancelAppointment();
                        }}
                        onCancel={() => {
                            setVisible(false);
                        }}
                    >
                        <VitalInformation
                            bill={bill}
                            information={clinical}
                            visit_id={visit_id}
                            refrence_number={refrence_number}
                            refrence_id={refrence_id}
                            module={module}
                            formToShow={formToShow}
                            // Pass the formToShow prop

                            attributes={attributes}
                            callback={() => {
                                new Promise(async (resolve, reject) => {
                                    // Get Clinical Data
                                    const clinicalData = await getClinicalData(visit_id);

                                    resolve(clinicalData);
                                });

                                setVisible(false);
                            }}
                        />
                    </Modal>
                )}
            </div>
            {/* <div> */}
            {/* </div> */}
            {/* </div> */}

            {loading ? (
                <Skeleton />
            ) : (
                <>
                    {/* <div className="card-div">
                        <div className="blood-section">
                            <div className="section">
                                <h3 className="blood-pressure">{t('BLOOD PRESSURE')}</h3>
                                <div className="blood-values-section values-section">
                                    <ValueCard label={t('Systolic')} value={clinical.srvbcd_bpsys} unit={t('mmHg')} />

                                    <ValueCard label={t('Diastolic')} value={clinical.srvbcd_bpdia} unit={t('mmHg')} />
                                </div>
                            </div>
                            {isTimeTracking ? <EventList isTableView={true} currentRoomPointer={currentRoomPointer}></EventList> : null}
                        </div>
                        <div className="measurement-section">
                            <div className="labelValue-section">
                                <ValueCard label={t('Height')} value={clinical.srvbcd_height} unit={t('cm')} className="label-value" />
                                <ValueCard label={t('Weight')} value={clinical.srvbcd_weight} unit={t('kg')} className="label-value" />
                                <ValueCard label={t('BMI')} value={clinical.srvbcd_bmi} unit={t('kg/m^2')} className="label-value" />
                                <ValueCard label={t('SpO2')} value={clinical.srvbcd_spo2} unit={t('%')} className="label-value" />
                                <ValueCard label={t('Temperature')} value={clinical.srvbcd_temperature} unit={t('°C')} className="label-value" />
                                <ValueCard label={t('Pulse')} value={clinical.srvbcd_pulse} unit={t('bpm')} className="label-value" />
                            </div>
                        </div>
                    </div> */}

                    <div>
                        <Text className='matric-title'>BP</Text>
                        <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
                            {data.map((group, index) => (
                                <Col key={index} xs={24} sm={12} md={6} className={index !== data.length - 1 ? 'column-border' : ''}>
                                    {group?.map((item, idx) => (
                                        <MetricItem key={idx} label={item.label} value={item.value} unit={item.unit} />
                                    ))}
                                </Col>
                            ))}
                        </Row>
                    </div>

                    {/* </Card> */}
                </>
            )}

            {/* {history.length >= 2 ? (
                <div className="">
                    <LineGraph data={history} />
                </div>
            ) : null} */}
        </Card>
    );
}

/**
 * Component styles and displays the label
 *
 * @param {*} param0
 * @returns
 */
// function ValueCard({ label, value, unit, className = 'value-card' }) {
//     return (
//         <div className={className}>
//             <label>{label}</label>

//             <h5>
//                 {value}
//                 <small>{unit}</small>
//             </h5>
//         </div>
//     );
// }
